import React from 'react';

export default function GenericPage({ title }) {
  return (
    <div className="animate-fade-in p-8 text-center text-gray-500 text-sm bg-white rounded shadow-sm border border-gray-100">
      【{title}】 页面组件准备就绪。
    </div>
  );
}
